import { LegalDocumentDataType } from '@oy/types';
import { getTranslation } from 'src/utilities/translator';

const getTitleAppendix = (product: string) => {
  switch (product) {
    case 'DISBURSEMENT':
      return 'Disbursement';
    case 'PAYMENT_AGGREGATOR':
      return 'Payment Aggregator';
    case 'PAYMENT_LINK':
      return 'Payment Link';
    case 'VCC':
      return 'VCC';
    case 'AP_AR':
      return 'AP & AR';
    default:
      return 'Unknown';
  }
};

export const getStepTitle = (document: LegalDocumentDataType) => {
  switch (document.type) {
    case 'DOCUMENT_DEFICIENCY':
      return 'Document Deficiency';
    case 'SERVICE_AGREEMENT':
      return getTranslation('common_service_aggrement');
    case 'TERMS_CONDITIONS':
      return getTranslation('common_terms_conditions');
    case 'CUSTOM_AGREEMENT':
      return getTranslation('common_service_aggrement');
    case 'APPENDIX':
      return `${getTranslation('common_appendix')} - ${getTitleAppendix(
        document.product ?? '',
      )}`;
    default:
      return 'Unknown Document';
  }
};
